import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-68a98179"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "go-to-link" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.itemsRendered)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.trackAdLink(_ctx.ad)), ["prevent"])),
          class: "btn btn-cta btn-sm pull-right open-account-btn",
          rel: "nofollow"
        }, "Open an Account"),
        _createTextVNode(" " + _toDisplayString(_ctx.bankName) + " ", 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            href: "",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.trackAdLink(_ctx.ad)), ["prevent"]))
          }, "Go to Website")
        ]),
        _createElementVNode("img", {
          class: "tPixel",
          src: _ctx.$filters.formatTrackingFilter(_ctx.ad.pixel)
        }, null, 8, _hoisted_3)
      ]))
    : _createCommentVNode("", true)
}